import { IEnvironmentSettings } from '@partners/settings';

export const environment: IEnvironmentSettings = {
  production: true,
  apiUrl: 'https://partners-cal.cal-online.co.il/CalsaleWS/api',
  calEdaUri: 'https://api.cal-online.co.il/CalEda',
  trackerUrl: 'https://partners-cal.cal-online.co.il/CalsaleWS/api/tracker/customer/journey',
  isSecured: true,
  isProxy: true,
  isMockMode: false,
  isDevMode: false,
  rootEndpoint: 'digitalwallet',
  isScanOcrDisabled: false,
  gtmConfig: {
    trackingCode: 'GTM-WCP67H3',
    gtmAuth: '',
    gtmPreview: '',
    gtmCookiesWin: '',
    applicationName: 'partners'
  },
  scanConfig: {
    apiUrl: 'https://partners-cal.cal-online.co.il/CalsaleWS/api/digitalwallet/card/scan-process',
    iframeStyle: 'height: 100%; width: 100%;',
    classNames: 'scan-container',
    completeCallbackUrl: `${window.location.origin}/scan/scan-document?ignoreNavigation=true`
  }
};
